import { Location } from "@angular/common";
import { HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { Component, OnInit, OnDestroy } from "@angular/core";
import { FormArray, FormControl, FormGroup } from "@angular/forms";
import { fadeInRightAnimation } from "src/@fury/animations/fade-in-right.animation";
import { fadeInUpAnimation } from "src/@fury/animations/fade-in-up.animation";
import { scaleInAnimation } from "src/@fury/animations/scale-in.animation";
import { ErrorType } from "src/app/enums/error-type.enum";
import { ApiService } from "src/app/services/api.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import endpoints from "src/app/helpers/endpoints";

@Component({
  selector: "fury-global-plan-pricing",
  templateUrl: "./global-plan-pricing.component.html",
  styleUrls: ["./global-plan-pricing.component.scss"],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class GlobalPlanPricingComponent implements OnInit, OnDestroy {
  globalPricingForm = new FormGroup({
    updatedPrices: new FormArray([
      new FormGroup({
        pricingOption: new FormControl("Monthly"),
        displayPrice: new FormControl(""),
        discountedPrice: new FormControl(""),
      }),
      new FormGroup({
        pricingOption: new FormControl("Yearly"),
        displayPrice: new FormControl(""),
        discountedPrice: new FormControl(""),
      }),
      new FormGroup({
        pricingOption: new FormControl("2 Years"),
        displayPrice: new FormControl(""),
        discountedPrice: new FormControl(""),
      }),
      new FormGroup({
        pricingOption: new FormControl("3 Years"),
        displayPrice: new FormControl(""),
        discountedPrice: new FormControl(""),
      }),
      new FormGroup({
        pricingOption: new FormControl("4 Years"),
        displayPrice: new FormControl(""),
        discountedPrice: new FormControl(""),
      }),
      new FormGroup({
        pricingOption: new FormControl("5 Years"),
        displayPrice: new FormControl(""),
        discountedPrice: new FormControl(""),
      }),
    ]),
  });
  ngUnsubscribe = new Subject<void>();

  constructor(private apiService: ApiService, public location: Location) {}

  ngOnInit() {}
  get planControl() {
    return this.globalPricingForm.get("updatedPrices") as FormArray;
  }

  update() {
    if (this.globalPricingForm.valid) {
      const payload = this.createPayload();
      this.apiService
        .patch(
          endpoints.settings.globalPlanPricing.updateBulkPlanPrices,
          payload
        )
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe({
          next: (res: HttpResponse<any>) => {
            if (res.body) {
              this.apiService.alert(res.body?.message, ErrorType.Success);
             const updatedPrices = this.globalPricingForm.get("updatedPrices") as FormArray;
             updatedPrices.reset();
            }
          },
          error: (error: HttpErrorResponse) => {
            this.apiService.alert(error.message, ErrorType.Error);
          },
        });
    } else {
      this.globalPricingForm.markAllAsTouched();
    }
  }
  createPayload() {
    const data: any = {};
    data.updatedPrices = this.globalPricingForm.value.updatedPrices.map(
      (item) => {
        return {
          pricingOption: item.pricingOption,
          displayPrice:
            item.displayPrice && item.displayPrice !== "NaN"
              ? item.displayPrice
              : 0,
          discountedPrice:
            item.discountedPrice && item.discountedPrice !== "NaN"
              ? item.discountedPrice
              : 0,
        };
      }
    );
    return data;
  }
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
